import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Logo from "../../../assets/images/Logo.svg";
import resetPassBanner from "../../../assets/images/reset-password-banner.png";
import Image from "react-bootstrap/Image";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Formik } from "formik";
import { SvgIcons } from "../../../components/common/SvgIcons";
import { Link, useNavigate, useParams } from "react-router-dom";
import { resetPassword } from "../../../services/authService";
import InputPassword from "../../../components/common/InputPassword";
import Loader from "../../../components/common/Loader";
import { ResetPasswordSchema } from "../../../validations/Auth";
import { nameBasedRoutes } from "../../../router/public";
import { toast } from "react-toastify";
import { MESSAGES } from "../../../constants/messages";

export const ResetPassword = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  /**
   * Submit Method to call when user clicks on Reset password button
   * @date 15/02/2023 - 19:14:03
   *
   * @async
   * @param {string} password
   * @returns {*}
   */
  const submitForm = async (password: string) => {
    setLoading(true);
    await resetPassword({ password: password, token: token ? token : "" })
      .then((response) => {
        toast.success(MESSAGES.passwordReset);
        navigate('/login');
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error?.response?.data?.message);
      });
  };

  return (
    <>
      <Row className="g-0 vh-100 position-relative">
        <Col md={6} lg={4} className="h-100">
          <div className="h-100  p-4 p-md-4 pe-md-0 position-relative ps-md-0 text-center w-100 pb-md-0">
            <Row className="align-items-center g-0 justify-content-center login-left-inner pb-3">
              <Col md={10} lg={10} xl={8} xxl={8}>
                <div className="mb-2 pb-2">
                  <Link
                    to={nameBasedRoutes.home.path}
                    className="d-inline-block"
                  >
                    <Image
                      className="img-fluid"
                      src={Logo}
                      alt="Logo"
                      width={129}
                      height={130}
                    />
                  </Link>
                </div>

                <h1 className="d-inline-block fw-bold h4 mb-1 mt-1 pt-2 w-100">
                  Reset Password
                </h1>
                <p className="mb-1 pt-1 fs-13 gray-color">Enter new password</p>
                <Formik
                  validationSchema={ResetPasswordSchema}
                  onSubmit={(values, actions) => {
                    actions.setSubmitting(false);
                    submitForm(values.password);
                  }}
                  initialValues={{
                    password: "",
                    confirmPassword: "",
                  }}
                >
                  {({
                    handleSubmit,
                    handleChange,
                    handleBlur,
                    values,
                    errors,
                    touched,
                  }) => (
                    <Form
                      className="text-start pt-4"
                      noValidate
                      onSubmit={handleSubmit}
                    >
                      <InputPassword
                        controlId="password"
                        label="Password"
                        placeholder="Enter Password"
                        touched={touched.password}
                        handleBlur={handleBlur}
                        handleChange={handleChange}
                        errorsField={errors.password}
                        value={values.password}
                      />
                      <InputPassword
                        controlId="confirmPassword"
                        label="Confirm password"
                        placeholder="Enter Password"
                        handleBlur={handleBlur}
                        touched={touched.confirmPassword}
                        handleChange={handleChange}
                        errorsField={errors.confirmPassword}
                        value={values.confirmPassword}
                      />
                      <Button
                        className="fw-bold w-100"
                        variant="primary"
                        type="submit"
                      >
                        Reset Password
                      </Button>
                    </Form>
                  )}
                </Formik>
              </Col>
            </Row>
          </div>
        </Col>
        <Col
          md={6}
          lg={8}
          className="mobileBannerActive h-100 position-fixed right-0"
        >
          <Image
            className="h-100  w-100"
            src={resetPassBanner}
            alt="Forgot Password Banner"
          />
          <div className="bottom-0 h4 pb-3 position-absolute pt-3 w-100 white-color text-center posti right-text-overlapp mb-0">
            CRANE SAFETY EXPERTS
          </div>
        </Col>
      </Row>

      <Loader isLoading={loading} />
    </>
  );
};
